// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__24Ibe","resendInfoText":"OnGoingPaymentBox_resendInfoText__3lwiv"};